import axios from '@/utils/api'

const actions = {

  async getAllConversas ({ context }) {
    const data = await axios({
      method: 'GET',
      url: 'contagem-conversas'
    })

    return data
  }
}
export default {
  namespaced: true,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/relatorios_ouvidoria/carddashboardRelatorios.js